import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import MobileFilterContainer from './MobileFilterContainer.styled';
import { ToggleSlider, ToggleSwitch } from '../../base/Toggle.styled';
import ScreenReaderText from '../../base/ScreenReaderText.styled';

const ToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  span {
    font-family: 'Nunito', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    color: #373737;
    line-height: 120%;
  }
`;

export default function MobileApplicationOnlyFilter({ applicationsOnly, handleClick }) {
  const {
    customAliases: { 
      alias_favorites: favoritesAlias = 'Favorites',
    },
  } = useSelector(state => state.profile);

  return (
    <MobileFilterContainer>
        <ToggleContainer>
            <span aria-hidden="true">Show Open Applications Only</span>
            <ToggleSwitch htmlFor="applications_only">
                <ScreenReaderText>Show Open Applications Only</ScreenReaderText>
                <input
                    id="applications_only"
                    type="checkbox"
                    checked={applicationsOnly === 'yes'}
                    onChange={handleClick}
                />
                <ToggleSlider className="toggle-slider" />
            </ToggleSwitch>
        </ToggleContainer>
    </MobileFilterContainer>
  );
}

MobileApplicationOnlyFilter.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};